import {StandardAction} from './standard-action';

export class DialogAction extends StandardAction {
  public closeDialog: boolean;

  constructor(id: string, name: string, closeDialog = true) {
    super(id, null, name);
    this.closeDialog = closeDialog;
  }
}
